import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { TeamnoteApiService } from '../../../../../app/api/teamnote-api.service'
import { MessageVideoCallInfo } from '../../../../models/message-video-call'
import { VideoCallMessageService } from '../messages/video-call-message/video-call-message.service'
import { UserContactService } from '../../../services/data/user-contact/user-contact.service'
import { FileFactoryService } from '../../../../../app/utilities/file-factory/file-factory.service'

@Injectable({
  providedIn: 'root'
})
export class VideoCallService {
  isVideoCalling: boolean = false
  isVideoCalling$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

  currentChatId: any = null
  videoCallMessage: MessageVideoCallInfo = null
  isCallByMe: any = null
  isGroup: boolean = false
  callerUserId: string = ''

  constructor(
    private _teamnoteApiService: TeamnoteApiService,
    private _videoCallMessageService: VideoCallMessageService,
    private _userContactService: UserContactService,
    private _fileFactoryService: FileFactoryService
  ) {}

  setVideoCallMessage(
    videocallInfo: MessageVideoCallInfo,
    chat_id: string,
    isCallByMe: boolean,
    isGroup: boolean,
    callerUserId: string,
    callback: Function
  ): void {
    this.isCallByMe = isCallByMe
    this.isGroup = isGroup
    this.isVideoCalling = true
    this.callerUserId = callerUserId
    this.updateVideoCallStatus()

    this.videoCallMessage = videocallInfo
    this.currentChatId = chat_id

    if (!this.videoCallMessage) {
      alert('video call message is invalid')
      return
    }

    if (callback) {
      // start a video call after getting target video call info
      // (e.g ws_endpoint, room_id, pin)
      callback()
    }
  }

  getVideoCallInfo(): MessageVideoCallInfo {
    return this.videoCallMessage
  }

  initVideoCallInfo(callback?: Function): void {
    this.isCallByMe = null
    this.videoCallMessage = null
    this.currentChatId = null
    this.isVideoCalling = false
    this.isGroup = false
    this.callerUserId = ''
    this.updateVideoCallStatus()

    // this._videoCallMessageService.initTargetVideoCallInfo();
    if (callback) {
      callback()
    }
  }

  updateVideoCallStatus(): void {
    this.isVideoCalling$.next(this.isVideoCalling)
  }

  // start a video call session
  beginVideoCall(chat_id: string, is_group: boolean, caller: string, startVideoSession: Function): void {

    this._teamnoteApiService.callApi(
      '/group/voice_chat/start',
      { chat_id: chat_id },
      (resp: any) => {
        if (resp.is_success) {
          // start an video call with the user in the current chat room
          this.setVideoCallMessage(resp, chat_id, true, is_group, caller, () => {
            if (startVideoSession) {
              startVideoSession()
            }
          })
        }
      },
      (err: any) => {
        console.error(err)
      }
    )
  }

  // finish current video call session
  endVideoCall(callback?: Function): void {
    console.log('stop a video call')
    this._teamnoteApiService.callApi(
      '/group/voice_chat/finish',
      { chat_id: this.currentChatId },
      (resp: any) => {
        console.log(resp)
        this.initVideoCallInfo()

        if (callback) {
          callback()
        }
      },
      (err: any) => {
        console.error(err)
        // finish false, means that the other party has called /group/voice_chat/finish api
        this.initVideoCallInfo()

        if (callback) {
          callback()
        }
      }
    )
  }

  getAvatarByUserId(userId: string): Promise<any> {
    let user = this._userContactService.getUserContactByUserId(userId)

    if (user) {
      let userInfo = {
        name: user.name,
        avatarImageSrc: 'url(/assets/images/general/default_avatar.png)'
      }

      return new Promise((resolve, reject) => {
        if (user.pic && user.pic != 'None') {
          this._fileFactoryService.getFileByAttachmentId(
            user.pic,
            (imageUrl: any) => {
              userInfo.avatarImageSrc = imageUrl
              resolve(userInfo)
            },
            (err: any) => {
              resolve(userInfo)
            },
            false,
            false,
            true
          )
        } else {
          resolve(userInfo)
        }
      })
    }
  }
}
